export class AccountsConfig {
  bitfinex?: Array<string>;
  bitfinexSwap?: Array<number>;
}
